import React, {FC} from 'react';

import {useNavigationBar} from '@components/hooks/useNavigationBar';
import {NavigationBar} from '@components/molecules/NavigationBar';
import {BurgerBar} from '@components/molecules/BurgerBar';

const Header: FC = () => {
  const isNavigationBarEnabled = useNavigationBar();
  return isNavigationBarEnabled ? <NavigationBar /> : <BurgerBar />;
};

export {Header};
